import React from 'react';

export const AnimatedDots = () => {
  return (
    <div className="animated-dots" role="status" aria-label="Loading">
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};
